// Runtime wiring the host app provides once at startup: where the API is,
// how to persist small values (token, FX cache) and how to show a toast.
// Web passes localStorage + sonner; the Expo app passes SecureStore/
// AsyncStorage-backed storage + its own toast.
import { memoryStorage } from "./storage";

const noop = () => {};
const silentNotify = { success: noop, error: noop, info: noop };

const config = {
  baseUrl: "http://localhost:8080",
  storage: memoryStorage,
  notify: silentNotify,
};

const listeners = new Set();

/** Set any of { baseUrl, storage, notify }. Safe to call more than once. */
export function configureCore(options = {}) {
  if (options.baseUrl) config.baseUrl = String(options.baseUrl).replace(/\/$/, "");
  if (options.storage) config.storage = options.storage;
  if (options.notify) config.notify = { ...silentNotify, ...options.notify };
  listeners.forEach((fn) => fn(config));
  return config;
}

export const getConfig = () => config;

/** Internal: modules that cache something derived from config subscribe here. */
export function onConfigChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
